<app-table [data]="subCommittees" [columns]="tableColumns" [pageSize]="50" [internalScrolling]="true" id="table-subCommittees"></app-table>
